import { SCORING_TYPE_KEYS } from "constants/scoring";
import { flatten, pick, values } from "lodash";

export const convertScoringHitsToTree = (content = []) => {
  const result = [];
  if (!content?.length) {
    return result;
  }

  for (const contentHit of content) {
    const { id, paragraphStats, ...content } = contentHit;
    const stats = pick(paragraphStats, SCORING_TYPE_KEYS);
    const hits = flatten(values(stats)).filter(Boolean);

    result.push({ ...content, hits, id, paragraphStats });
  }

  return result;
};
